import { CompassCardUI } from '@scale/compass-ui/types';
import { addDays } from 'date-fns';
import {
  UpdateReferralRatesCardShared,
  type UpdateReferralRatesSchemaType,
  type UpdateReferralRatesContext,
  UPDATE_REFERRAL_RATES,
} from '@scale/genai-compass-shared/cards/update_referral_rates';
import UpdateReferralRatesCardComponent from './UpdateReferralRatesCardComponent';
import { faShareNodes } from '@fortawesome/pro-solid-svg-icons';

export const DEFAULT_EXPIRES_IN_DAYS = 30;
export const MAX_EXPIRES_IN_DAYS = 365;
export const MIN_RATE_AMOUNT = 0;
export const MAX_RATE_AMOUNT = 500;

const defaultContext: UpdateReferralRatesContext = {
  cardType: UPDATE_REFERRAL_RATES,
  selectedColumnIdWithWorkerIds: '',
  rateAmountDollars: 0,
  expireDate: addDays(new Date(), DEFAULT_EXPIRES_IN_DAYS),
  sendComms: false,
};

export const UpdateReferralRatesCardInfo: CompassCardUI<UpdateReferralRatesSchemaType> = {
  ...UpdateReferralRatesCardShared,
  title: 'Update Referral Rates',
  icon: 'edit',
  toolTip: 'Update referral rates for specified contributors.',
  defaultContext,
  ownerTeam: 'Pay / Growth',
  showOutput: true,
  legacyComponent: UpdateReferralRatesCardComponent,
  button: {
    icon: faShareNodes,
  },
};
